<template>
  <div>
    <VModal
      title="Add Recipients"
      version="new"
      classType="clean"
      v-if="isOpen"
      :actions="actions"
      @close="onClickBackdrop"
    >
      <div class="content-wrapper">
        <div class="modal-description">
          <h3>
            These contacts will receive
            <span class="accentuated-text">Daily summary</span> of sent mail
          </h3>
        </div>
        <VForm
          :name="name"
          :initialValues="{ addingElements: elements }"
          :fields="field"
          :disabled="!isValid"
        ></VForm>
      </div>
    </VModal>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VModal from "@/components/VModal";
import withFormUtils from "@/mixins/withFormUtils";
import { email } from "@/utils/validations";

export default Vue.component("VElementsAddingModal", {
  props: {
    // name: VueTypes.string,
    isOpen: VueTypes.bool,
    elements: VueTypes.array
  },

  components: {
    VForm: () => import("./VForm.vue"),
    VModal
  },

  data() {
    return {
      name: "addElementsModalForm"
    };
  },

  mixins: [withFormUtils],

  computed: {
    isSaveDisabled() {
      // return this.getValue("addingElements", this.name).length === 0;
    },

    field() {
      return [
        {
          name: "addingElements",
          label: "Recipients",
          placeholder: "Add email...",
          elementType: "tagsCreator",
          extraClass: "notifications-emails",
          version: "new",
          valueValidationFunc: this.inputTagValidation,
          preventEllipsis: true,
          minValuesCount: 1
        }
      ];
    },

    actions() {
      return [
        {
          label: "Cancel",
          value: "cancel",
          noBorder: true,
          inverted: true,
          type: "primary",
          size: "wide",
          click: () => {
            this.$emit("close");

            this.initializeForm({
              formName: this.name,
              fields: { addingElements: this.elements }
            });
          }
        },
        {
          label: "Add",
          disabled: this.isSaveDisabled,
          type: "primary",
          value: "send",
          size: "regular",
          click: () => {
            this.$emit("save", this.getValue("addingElements"));
            this.$emit("close");
          }
        }
      ];
    }
  },

  methods: {
    inputTagValidation(value) {
      if (!value) {
        return "Email cannot be empty";
      }

      return email(value);
    },

    onClickBackdrop() {
      this.$emit("close");
    }
  }
  //
  // created() {
  //   console.log(this.getField(this.field[0].name, this.name))
  //   if (!this.getField(this.field[0].name, this.name)) {
  //     this.registerFields({
  //       formName: this.name,
  //       fields: this.field
  //     });
  //   }
  // }
});
</script>

<style lang="scss" scoped>
.modal-description {
  font-size: 18px;
  line-height: 1.4;
  color: $tertiary-text-color;
  padding: 0 30px 15px;

  .accentuated-text {
    color: $primary-text-color;
  }
}

.input-title {
  text-align: left;
  width: auto;
  margin: 0 0 14px 8px;
  font-weight: 600;
}

.tooltip {
  height: 25px;
  font-size: 14px;
  font-family: "Lato-Light", sans-serif;
  line-height: 17px;
  text-align: left;

  color: $primary-color;
}
</style>
